/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddOrUpdateGoodsVo,
  BatchUpdateOriginReqVo,
  ComposedGoodsVo,
  ResponseBoolean,
  ResponseCombinedGoodsListForPackVo,
  ResponseComposedGoodsVo,
  ResponseGoodsComposeDetailVo,
  ResponseGoodsListForPackVo,
  ResponseGoodsPackingHistoryVo,
  ResponseGoodsVo,
  ResponseListAddOrUpdateGoodsVo,
  ResponseListParcelTrackingNumberVo,
  ResponseListParcelVo,
  ResponseListPurchasePlatformOrderFeeVo,
  ResponseListString,
  ResponseLong,
  ResponseOrderDetailOrderDetailGoodsVo,
  ResponseParcelVo,
  ResponseString,
  ResponseTruckInfoVo,
  TruckInfoVo,
  UpdateCombinedPackingRemarkVo,
  UpdateGoodsFeeVo,
  UpdateGoodsStatusBatchVo,
  UpdatePackFeeVo,
  UpdateTrackingNumberByGoodsPlatformNoVo,
  UpdateVolumeVo,
} from '../models/index';
import {
    AddOrUpdateGoodsVoFromJSON,
    AddOrUpdateGoodsVoToJSON,
    BatchUpdateOriginReqVoFromJSON,
    BatchUpdateOriginReqVoToJSON,
    ComposedGoodsVoFromJSON,
    ComposedGoodsVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseCombinedGoodsListForPackVoFromJSON,
    ResponseCombinedGoodsListForPackVoToJSON,
    ResponseComposedGoodsVoFromJSON,
    ResponseComposedGoodsVoToJSON,
    ResponseGoodsComposeDetailVoFromJSON,
    ResponseGoodsComposeDetailVoToJSON,
    ResponseGoodsListForPackVoFromJSON,
    ResponseGoodsListForPackVoToJSON,
    ResponseGoodsPackingHistoryVoFromJSON,
    ResponseGoodsPackingHistoryVoToJSON,
    ResponseGoodsVoFromJSON,
    ResponseGoodsVoToJSON,
    ResponseListAddOrUpdateGoodsVoFromJSON,
    ResponseListAddOrUpdateGoodsVoToJSON,
    ResponseListParcelTrackingNumberVoFromJSON,
    ResponseListParcelTrackingNumberVoToJSON,
    ResponseListParcelVoFromJSON,
    ResponseListParcelVoToJSON,
    ResponseListPurchasePlatformOrderFeeVoFromJSON,
    ResponseListPurchasePlatformOrderFeeVoToJSON,
    ResponseListStringFromJSON,
    ResponseListStringToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponseOrderDetailOrderDetailGoodsVoFromJSON,
    ResponseOrderDetailOrderDetailGoodsVoToJSON,
    ResponseParcelVoFromJSON,
    ResponseParcelVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
    ResponseTruckInfoVoFromJSON,
    ResponseTruckInfoVoToJSON,
    TruckInfoVoFromJSON,
    TruckInfoVoToJSON,
    UpdateCombinedPackingRemarkVoFromJSON,
    UpdateCombinedPackingRemarkVoToJSON,
    UpdateGoodsFeeVoFromJSON,
    UpdateGoodsFeeVoToJSON,
    UpdateGoodsStatusBatchVoFromJSON,
    UpdateGoodsStatusBatchVoToJSON,
    UpdatePackFeeVoFromJSON,
    UpdatePackFeeVoToJSON,
    UpdateTrackingNumberByGoodsPlatformNoVoFromJSON,
    UpdateTrackingNumberByGoodsPlatformNoVoToJSON,
    UpdateVolumeVoFromJSON,
    UpdateVolumeVoToJSON,
} from '../models/index';

export interface GoodsAddBaseGoodsOrderIdPostRequest {
    orderId: number;
    addOrUpdateGoodsVo?: AddOrUpdateGoodsVo;
}

export interface GoodsAddParcelTrackingNumbersGoodsIdPostRequest {
    goodsId: number;
    trackingNumbers: Array<string>;
    purchaseOrderNumber?: string;
}

export interface GoodsAddPurchasePlatformOrderNoGoodsIdPostRequest {
    goodsId: number;
    purchasePlatformOrderNo: string;
}

export interface GoodsBatchAddGoodsOrderIdPostRequest {
    orderId: number;
    addOrUpdateGoodsVo?: Array<AddOrUpdateGoodsVo>;
}

export interface GoodsBatchUpdateGoodsOrderIdPostRequest {
    orderId: number;
    addOrUpdateGoodsVo?: Array<AddOrUpdateGoodsVo>;
}

export interface GoodsCombinedGoodsIdPackingRemarkPutRequest {
    goodsId: number;
    updateCombinedPackingRemarkVo?: UpdateCombinedPackingRemarkVo;
}

export interface GoodsComposeDetailOrderIdGetRequest {
    orderId: number;
}

export interface GoodsComposeDetailOrderIdPostRequest {
    orderId: number;
    composedGoodsVo?: Array<ComposedGoodsVo>;
}

export interface GoodsCopyGoodsIdPostRequest {
    goodsId: number;
}

export interface GoodsDeleteGoodsIdDeleteRequest {
    goodsId: number;
    orderId: number;
}

export interface GoodsDetailGoodsIdGetRequest {
    goodsId: number;
}

export interface GoodsExcelBatchUpdateGoodsExcelPostRequest {
    file: Blob;
}

export interface GoodsGetCombinedGoodsBaseGoodsIdGetRequest {
    baseGoodsId: number;
}

export interface GoodsGetGoodsListForPackOrderIdGetRequest {
    orderId: number;
}

export interface GoodsGoodsCimbinedAllOrderIdGetRequest {
    orderId: number;
}

export interface GoodsGoodsCombinedCancelGoodsIdPostRequest {
    goodsId: number;
}

export interface GoodsGoodsCombinedPackFeeGoodsIdPostRequest {
    goodsId: number;
    updatePackFeeVo?: UpdatePackFeeVo;
}

export interface GoodsGoodsCombinedVolumnGoodsIdPostRequest {
    goodsId: number;
    updateVolumeVo?: UpdateVolumeVo;
}

export interface GoodsGoodsIdPackingHistoryGetRequest {
    goodsId: number;
}

export interface GoodsGoodsPackOrderIdGetRequest {
    orderId: number;
}

export interface GoodsOriginBatchPutRequest {
    batchUpdateOriginReqVo?: BatchUpdateOriginReqVo;
}

export interface GoodsParcelListGoodsIdGetRequest {
    goodsId: number;
}

export interface GoodsParcelTrackingNumberGoodsIdDeleteRequest {
    goodsId: number;
    parcelId: number;
}

export interface GoodsParcelTrackingNumberGoodsIdGetRequest {
    goodsId: number;
}

export interface GoodsParcelTrackingNumberGoodsIdPostRequest {
    goodsId: number;
    trackingNumber: string;
    purchaseOrderNumber?: string;
}

export interface GoodsPictureGoodsIdGetRequest {
    goodsId: number;
}

export interface GoodsPictureParcelGoodsIdGetRequest {
    goodsId: number;
}

export interface GoodsPull1688TrackingNumberGoodsIdPostRequest {
    goodsId: number;
}

export interface GoodsPurchasePlatformOrderFeeOrderIdGetRequest {
    orderId: number;
}

export interface GoodsSetOriginPackageOutboundGoodsIdPutRequest {
    goodsId: number;
    originPackageOutbound: number;
}

export interface GoodsTruckInfoGoodsIdGetRequest {
    goodsId: number;
}

export interface GoodsTruckInfoGoodsIdPostRequest {
    goodsId: number;
    truckInfoVo?: TruckInfoVo;
}

export interface GoodsUpdateComposedGoodsQuantityOrderIdPostRequest {
    orderId: number;
    composedGoodsVo?: Array<ComposedGoodsVo>;
}

export interface GoodsUpdateGoodsFeePostRequest {
    updateGoodsFeeVo?: Array<UpdateGoodsFeeVo>;
}

export interface GoodsUpdateGoodsRemarkGoodsIdPostRequest {
    goodsId: number;
    remark: string;
}

export interface GoodsUpdateGoodsStatusBatchPostRequest {
    updateGoodsStatusBatchVo?: UpdateGoodsStatusBatchVo;
}

export interface GoodsUpdateParcelTrackingNumberGoodsIdPostRequest {
    goodsId: number;
    parcelId: number;
    trackingNumber: string;
    purchaseOrderNumber?: string;
}

export interface GoodsUpdatePostRequest {
    addOrUpdateGoodsVo?: AddOrUpdateGoodsVo;
}

export interface GoodsUpdateTrackingNumberByGoodsPlatformNoPostRequest {
    updateTrackingNumberByGoodsPlatformNoVo?: Array<UpdateTrackingNumberByGoodsPlatformNoVo>;
}

/**
 * 
 */
export class GoodsControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 添加基础商品
     */
    async goodsAddBaseGoodsOrderIdPostRaw(requestParameters: GoodsAddBaseGoodsOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsAddBaseGoodsOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/addBaseGoods/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateGoodsVoToJSON(requestParameters['addOrUpdateGoodsVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 添加基础商品
     */
    async goodsAddBaseGoodsOrderIdPost(requestParameters: GoodsAddBaseGoodsOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.goodsAddBaseGoodsOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 给商品批量添加运单号
     */
    async goodsAddParcelTrackingNumbersGoodsIdPostRaw(requestParameters: GoodsAddParcelTrackingNumbersGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListParcelVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsAddParcelTrackingNumbersGoodsIdPost().'
            );
        }

        if (requestParameters['trackingNumbers'] == null) {
            throw new runtime.RequiredError(
                'trackingNumbers',
                'Required parameter "trackingNumbers" was null or undefined when calling goodsAddParcelTrackingNumbersGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['trackingNumbers'] != null) {
            queryParameters['trackingNumbers'] = requestParameters['trackingNumbers'];
        }

        if (requestParameters['purchaseOrderNumber'] != null) {
            queryParameters['purchaseOrderNumber'] = requestParameters['purchaseOrderNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/addParcelTrackingNumbers/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListParcelVoFromJSON(jsonValue));
    }

    /**
     * 
     * 给商品批量添加运单号
     */
    async goodsAddParcelTrackingNumbersGoodsIdPost(requestParameters: GoodsAddParcelTrackingNumbersGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListParcelVo> {
        const response = await this.goodsAddParcelTrackingNumbersGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 添加商品平台单号
     */
    async goodsAddPurchasePlatformOrderNoGoodsIdPostRaw(requestParameters: GoodsAddPurchasePlatformOrderNoGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsAddPurchasePlatformOrderNoGoodsIdPost().'
            );
        }

        if (requestParameters['purchasePlatformOrderNo'] == null) {
            throw new runtime.RequiredError(
                'purchasePlatformOrderNo',
                'Required parameter "purchasePlatformOrderNo" was null or undefined when calling goodsAddPurchasePlatformOrderNoGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['purchasePlatformOrderNo'] != null) {
            queryParameters['purchasePlatformOrderNo'] = requestParameters['purchasePlatformOrderNo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/addPurchasePlatformOrderNo/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 添加商品平台单号
     */
    async goodsAddPurchasePlatformOrderNoGoodsIdPost(requestParameters: GoodsAddPurchasePlatformOrderNoGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsAddPurchasePlatformOrderNoGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量添加商品
     */
    async goodsBatchAddGoodsOrderIdPostRaw(requestParameters: GoodsBatchAddGoodsOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListAddOrUpdateGoodsVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsBatchAddGoodsOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/batchAddGoods/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['addOrUpdateGoodsVo']!.map(AddOrUpdateGoodsVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListAddOrUpdateGoodsVoFromJSON(jsonValue));
    }

    /**
     * 
     * 批量添加商品
     */
    async goodsBatchAddGoodsOrderIdPost(requestParameters: GoodsBatchAddGoodsOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListAddOrUpdateGoodsVo> {
        const response = await this.goodsBatchAddGoodsOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单详情 更新数量，入参很多，只填goodsId和数量就行
     */
    async goodsBatchUpdateGoodsOrderIdPostRaw(requestParameters: GoodsBatchUpdateGoodsOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsBatchUpdateGoodsOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/batchUpdateGoods/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['addOrUpdateGoodsVo']!.map(AddOrUpdateGoodsVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 订单详情 更新数量，入参很多，只填goodsId和数量就行
     */
    async goodsBatchUpdateGoodsOrderIdPost(requestParameters: GoodsBatchUpdateGoodsOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.goodsBatchUpdateGoodsOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新合包商品的包装作业备注
     */
    async goodsCombinedGoodsIdPackingRemarkPutRaw(requestParameters: GoodsCombinedGoodsIdPackingRemarkPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsCombinedGoodsIdPackingRemarkPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/combined/{goodsId}/packing-remark`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCombinedPackingRemarkVoToJSON(requestParameters['updateCombinedPackingRemarkVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新合包商品的包装作业备注
     */
    async goodsCombinedGoodsIdPackingRemarkPut(requestParameters: GoodsCombinedGoodsIdPackingRemarkPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsCombinedGoodsIdPackingRemarkPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取订单内商品合包详情
     */
    async goodsComposeDetailOrderIdGetRaw(requestParameters: GoodsComposeDetailOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGoodsComposeDetailVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsComposeDetailOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/compose/detail/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGoodsComposeDetailVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取订单内商品合包详情
     */
    async goodsComposeDetailOrderIdGet(requestParameters: GoodsComposeDetailOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGoodsComposeDetailVo> {
        const response = await this.goodsComposeDetailOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新订单内商品合包
     */
    async goodsComposeDetailOrderIdPostRaw(requestParameters: GoodsComposeDetailOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsComposeDetailOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/compose/detail/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['composedGoodsVo']!.map(ComposedGoodsVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新订单内商品合包
     */
    async goodsComposeDetailOrderIdPost(requestParameters: GoodsComposeDetailOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsComposeDetailOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 复制商品
     */
    async goodsCopyGoodsIdPostRaw(requestParameters: GoodsCopyGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGoodsVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsCopyGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/copy/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGoodsVoFromJSON(jsonValue));
    }

    /**
     * 
     * 复制商品
     */
    async goodsCopyGoodsIdPost(requestParameters: GoodsCopyGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGoodsVo> {
        const response = await this.goodsCopyGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除商品
     */
    async goodsDeleteGoodsIdDeleteRaw(requestParameters: GoodsDeleteGoodsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsDeleteGoodsIdDelete().'
            );
        }

        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsDeleteGoodsIdDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/delete/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除商品
     */
    async goodsDeleteGoodsIdDelete(requestParameters: GoodsDeleteGoodsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsDeleteGoodsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 商品详情
     */
    async goodsDetailGoodsIdGetRaw(requestParameters: GoodsDetailGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderDetailOrderDetailGoodsVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsDetailGoodsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/detail/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderDetailOrderDetailGoodsVoFromJSON(jsonValue));
    }

    /**
     * 
     * 商品详情
     */
    async goodsDetailGoodsIdGet(requestParameters: GoodsDetailGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderDetailOrderDetailGoodsVo> {
        const response = await this.goodsDetailGoodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传文件批量修改订单商品
     */
    async goodsExcelBatchUpdateGoodsExcelPostRaw(requestParameters: GoodsExcelBatchUpdateGoodsExcelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling goodsExcelBatchUpdateGoodsExcelPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/goods/excelBatchUpdateGoodsExcel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传文件批量修改订单商品
     */
    async goodsExcelBatchUpdateGoodsExcelPost(requestParameters: GoodsExcelBatchUpdateGoodsExcelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsExcelBatchUpdateGoodsExcelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据基础商品ID查询所在合包商品信息
     */
    async goodsGetCombinedGoodsBaseGoodsIdGetRaw(requestParameters: GoodsGetCombinedGoodsBaseGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseComposedGoodsVo>> {
        if (requestParameters['baseGoodsId'] == null) {
            throw new runtime.RequiredError(
                'baseGoodsId',
                'Required parameter "baseGoodsId" was null or undefined when calling goodsGetCombinedGoodsBaseGoodsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/getCombinedGoods/{baseGoodsId}`.replace(`{${"baseGoodsId"}}`, encodeURIComponent(String(requestParameters['baseGoodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseComposedGoodsVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据基础商品ID查询所在合包商品信息
     */
    async goodsGetCombinedGoodsBaseGoodsIdGet(requestParameters: GoodsGetCombinedGoodsBaseGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseComposedGoodsVo> {
        const response = await this.goodsGetCombinedGoodsBaseGoodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取订单内商品列表 商品包装用
     */
    async goodsGetGoodsListForPackOrderIdGetRaw(requestParameters: GoodsGetGoodsListForPackOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGoodsListForPackVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsGetGoodsListForPackOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/getGoodsListForPack/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGoodsListForPackVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取订单内商品列表 商品包装用
     */
    async goodsGetGoodsListForPackOrderIdGet(requestParameters: GoodsGetGoodsListForPackOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGoodsListForPackVo> {
        const response = await this.goodsGetGoodsListForPackOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 判断订单内所有商品是否合包完毕
     */
    async goodsGoodsCimbinedAllOrderIdGetRaw(requestParameters: GoodsGoodsCimbinedAllOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsGoodsCimbinedAllOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/goods/cimbined/all/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 判断订单内所有商品是否合包完毕
     */
    async goodsGoodsCimbinedAllOrderIdGet(requestParameters: GoodsGoodsCimbinedAllOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.goodsGoodsCimbinedAllOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 取消合包要求
     */
    async goodsGoodsCombinedCancelGoodsIdPostRaw(requestParameters: GoodsGoodsCombinedCancelGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsGoodsCombinedCancelGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/goods/combined/cancel/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 取消合包要求
     */
    async goodsGoodsCombinedCancelGoodsIdPost(requestParameters: GoodsGoodsCombinedCancelGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsGoodsCombinedCancelGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新订单内合包商品的包装费用
     */
    async goodsGoodsCombinedPackFeeGoodsIdPostRaw(requestParameters: GoodsGoodsCombinedPackFeeGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsGoodsCombinedPackFeeGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/goods/combined/pack/fee/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePackFeeVoToJSON(requestParameters['updatePackFeeVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新订单内合包商品的包装费用
     */
    async goodsGoodsCombinedPackFeeGoodsIdPost(requestParameters: GoodsGoodsCombinedPackFeeGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsGoodsCombinedPackFeeGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新订单内合包商品体积重量等信息
     */
    async goodsGoodsCombinedVolumnGoodsIdPostRaw(requestParameters: GoodsGoodsCombinedVolumnGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsGoodsCombinedVolumnGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/goods/combined/volumn/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVolumeVoToJSON(requestParameters['updateVolumeVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新订单内合包商品体积重量等信息
     */
    async goodsGoodsCombinedVolumnGoodsIdPost(requestParameters: GoodsGoodsCombinedVolumnGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsGoodsCombinedVolumnGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 查看商品最近一次包装历史（仅后台，只读）
     */
    async goodsGoodsIdPackingHistoryGetRaw(requestParameters: GoodsGoodsIdPackingHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGoodsPackingHistoryVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsGoodsIdPackingHistoryGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/{goodsId}/packing-history`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGoodsPackingHistoryVoFromJSON(jsonValue));
    }

    /**
     * 
     * 查看商品最近一次包装历史（仅后台，只读）
     */
    async goodsGoodsIdPackingHistoryGet(requestParameters: GoodsGoodsIdPackingHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGoodsPackingHistoryVo> {
        const response = await this.goodsGoodsIdPackingHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取订单内合包商品列表 商品包装用
     */
    async goodsGoodsPackOrderIdGetRaw(requestParameters: GoodsGoodsPackOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCombinedGoodsListForPackVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsGoodsPackOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/goods/pack/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCombinedGoodsListForPackVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取订单内合包商品列表 商品包装用
     */
    async goodsGoodsPackOrderIdGet(requestParameters: GoodsGoodsPackOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCombinedGoodsListForPackVo> {
        const response = await this.goodsGoodsPackOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品管理·批量修改原产地
     * 商品管理·批量修改原产地
     */
    async goodsOriginBatchPutRaw(requestParameters: GoodsOriginBatchPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/origin/batch`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BatchUpdateOriginReqVoToJSON(requestParameters['batchUpdateOriginReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 商品管理·批量修改原产地
     * 商品管理·批量修改原产地
     */
    async goodsOriginBatchPut(requestParameters: GoodsOriginBatchPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.goodsOriginBatchPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据商品ID查询快递单列表
     */
    async goodsParcelListGoodsIdGetRaw(requestParameters: GoodsParcelListGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListParcelVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsParcelListGoodsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/parcelList/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListParcelVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据商品ID查询快递单列表
     */
    async goodsParcelListGoodsIdGet(requestParameters: GoodsParcelListGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListParcelVo> {
        const response = await this.goodsParcelListGoodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除商品的运单号
     */
    async goodsParcelTrackingNumberGoodsIdDeleteRaw(requestParameters: GoodsParcelTrackingNumberGoodsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsParcelTrackingNumberGoodsIdDelete().'
            );
        }

        if (requestParameters['parcelId'] == null) {
            throw new runtime.RequiredError(
                'parcelId',
                'Required parameter "parcelId" was null or undefined when calling goodsParcelTrackingNumberGoodsIdDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['parcelId'] != null) {
            queryParameters['parcelId'] = requestParameters['parcelId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/parcelTrackingNumber/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除商品的运单号
     */
    async goodsParcelTrackingNumberGoodsIdDelete(requestParameters: GoodsParcelTrackingNumberGoodsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsParcelTrackingNumberGoodsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据商品下快递单号查询快递信息
     */
    async goodsParcelTrackingNumberGoodsIdGetRaw(requestParameters: GoodsParcelTrackingNumberGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListParcelTrackingNumberVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsParcelTrackingNumberGoodsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/parcelTrackingNumber/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListParcelTrackingNumberVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据商品下快递单号查询快递信息
     */
    async goodsParcelTrackingNumberGoodsIdGet(requestParameters: GoodsParcelTrackingNumberGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListParcelTrackingNumberVo> {
        const response = await this.goodsParcelTrackingNumberGoodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 给商品添加运单号
     */
    async goodsParcelTrackingNumberGoodsIdPostRaw(requestParameters: GoodsParcelTrackingNumberGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseParcelVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsParcelTrackingNumberGoodsIdPost().'
            );
        }

        if (requestParameters['trackingNumber'] == null) {
            throw new runtime.RequiredError(
                'trackingNumber',
                'Required parameter "trackingNumber" was null or undefined when calling goodsParcelTrackingNumberGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['trackingNumber'] != null) {
            queryParameters['trackingNumber'] = requestParameters['trackingNumber'];
        }

        if (requestParameters['purchaseOrderNumber'] != null) {
            queryParameters['purchaseOrderNumber'] = requestParameters['purchaseOrderNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/parcelTrackingNumber/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseParcelVoFromJSON(jsonValue));
    }

    /**
     * 
     * 给商品添加运单号
     */
    async goodsParcelTrackingNumberGoodsIdPost(requestParameters: GoodsParcelTrackingNumberGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseParcelVo> {
        const response = await this.goodsParcelTrackingNumberGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据商品ID查询商品图片列表
     */
    async goodsPictureGoodsIdGetRaw(requestParameters: GoodsPictureGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsPictureGoodsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/picture/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStringFromJSON(jsonValue));
    }

    /**
     * 
     * 根据商品ID查询商品图片列表
     */
    async goodsPictureGoodsIdGet(requestParameters: GoodsPictureGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListString> {
        const response = await this.goodsPictureGoodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据商品ID查询商品下快递的实拍图片列表
     */
    async goodsPictureParcelGoodsIdGetRaw(requestParameters: GoodsPictureParcelGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsPictureParcelGoodsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/picture/parcel/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStringFromJSON(jsonValue));
    }

    /**
     * 
     * 根据商品ID查询商品下快递的实拍图片列表
     */
    async goodsPictureParcelGoodsIdGet(requestParameters: GoodsPictureParcelGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListString> {
        const response = await this.goodsPictureParcelGoodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 通过1688平台订单号主动获取快递单号
     */
    async goodsPull1688TrackingNumberGoodsIdPostRaw(requestParameters: GoodsPull1688TrackingNumberGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsPull1688TrackingNumberGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/pull1688TrackingNumber/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStringFromJSON(jsonValue));
    }

    /**
     * 
     * 通过1688平台订单号主动获取快递单号
     */
    async goodsPull1688TrackingNumberGoodsIdPost(requestParameters: GoodsPull1688TrackingNumberGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListString> {
        const response = await this.goodsPull1688TrackingNumberGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取采购平台订单费用
     */
    async goodsPurchasePlatformOrderFeeOrderIdGetRaw(requestParameters: GoodsPurchasePlatformOrderFeeOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListPurchasePlatformOrderFeeVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsPurchasePlatformOrderFeeOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/purchasePlatformOrderFee/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListPurchasePlatformOrderFeeVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取采购平台订单费用
     */
    async goodsPurchasePlatformOrderFeeOrderIdGet(requestParameters: GoodsPurchasePlatformOrderFeeOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListPurchasePlatformOrderFeeVo> {
        const response = await this.goodsPurchasePlatformOrderFeeOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 设置商品是否可以原包装出库
     */
    async goodsSetOriginPackageOutboundGoodsIdPutRaw(requestParameters: GoodsSetOriginPackageOutboundGoodsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsSetOriginPackageOutboundGoodsIdPut().'
            );
        }

        if (requestParameters['originPackageOutbound'] == null) {
            throw new runtime.RequiredError(
                'originPackageOutbound',
                'Required parameter "originPackageOutbound" was null or undefined when calling goodsSetOriginPackageOutboundGoodsIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['originPackageOutbound'] != null) {
            queryParameters['originPackageOutbound'] = requestParameters['originPackageOutbound'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/setOriginPackageOutbound/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 设置商品是否可以原包装出库
     */
    async goodsSetOriginPackageOutboundGoodsIdPut(requestParameters: GoodsSetOriginPackageOutboundGoodsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsSetOriginPackageOutboundGoodsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据货车入库号查询货车信息
     */
    async goodsTruckInfoGoodsIdGetRaw(requestParameters: GoodsTruckInfoGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseTruckInfoVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsTruckInfoGoodsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/truckInfo/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseTruckInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据货车入库号查询货车信息
     */
    async goodsTruckInfoGoodsIdGet(requestParameters: GoodsTruckInfoGoodsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseTruckInfoVo> {
        const response = await this.goodsTruckInfoGoodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改货车信息
     */
    async goodsTruckInfoGoodsIdPostRaw(requestParameters: GoodsTruckInfoGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsTruckInfoGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/truckInfo/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TruckInfoVoToJSON(requestParameters['truckInfoVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改货车信息
     */
    async goodsTruckInfoGoodsIdPost(requestParameters: GoodsTruckInfoGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsTruckInfoGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新合包商品数量
     */
    async goodsUpdateComposedGoodsQuantityOrderIdPostRaw(requestParameters: GoodsUpdateComposedGoodsQuantityOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling goodsUpdateComposedGoodsQuantityOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/updateComposedGoodsQuantity/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['composedGoodsVo']!.map(ComposedGoodsVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新合包商品数量
     */
    async goodsUpdateComposedGoodsQuantityOrderIdPost(requestParameters: GoodsUpdateComposedGoodsQuantityOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsUpdateComposedGoodsQuantityOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新商品费用 税点 开发票公司等信息
     */
    async goodsUpdateGoodsFeePostRaw(requestParameters: GoodsUpdateGoodsFeePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/updateGoodsFee`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateGoodsFeeVo']!.map(UpdateGoodsFeeVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新商品费用 税点 开发票公司等信息
     */
    async goodsUpdateGoodsFeePost(requestParameters: GoodsUpdateGoodsFeePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsUpdateGoodsFeePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新商品备注
     */
    async goodsUpdateGoodsRemarkGoodsIdPostRaw(requestParameters: GoodsUpdateGoodsRemarkGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsUpdateGoodsRemarkGoodsIdPost().'
            );
        }

        if (requestParameters['remark'] == null) {
            throw new runtime.RequiredError(
                'remark',
                'Required parameter "remark" was null or undefined when calling goodsUpdateGoodsRemarkGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['remark'] != null) {
            queryParameters['remark'] = requestParameters['remark'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/updateGoodsRemark/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新商品备注
     */
    async goodsUpdateGoodsRemarkGoodsIdPost(requestParameters: GoodsUpdateGoodsRemarkGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsUpdateGoodsRemarkGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量更新商品状态
     */
    async goodsUpdateGoodsStatusBatchPostRaw(requestParameters: GoodsUpdateGoodsStatusBatchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/updateGoodsStatusBatch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGoodsStatusBatchVoToJSON(requestParameters['updateGoodsStatusBatchVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量更新商品状态
     */
    async goodsUpdateGoodsStatusBatchPost(requestParameters: GoodsUpdateGoodsStatusBatchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsUpdateGoodsStatusBatchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 商品修改运单号
     */
    async goodsUpdateParcelTrackingNumberGoodsIdPostRaw(requestParameters: GoodsUpdateParcelTrackingNumberGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseParcelVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling goodsUpdateParcelTrackingNumberGoodsIdPost().'
            );
        }

        if (requestParameters['parcelId'] == null) {
            throw new runtime.RequiredError(
                'parcelId',
                'Required parameter "parcelId" was null or undefined when calling goodsUpdateParcelTrackingNumberGoodsIdPost().'
            );
        }

        if (requestParameters['trackingNumber'] == null) {
            throw new runtime.RequiredError(
                'trackingNumber',
                'Required parameter "trackingNumber" was null or undefined when calling goodsUpdateParcelTrackingNumberGoodsIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['parcelId'] != null) {
            queryParameters['parcelId'] = requestParameters['parcelId'];
        }

        if (requestParameters['trackingNumber'] != null) {
            queryParameters['trackingNumber'] = requestParameters['trackingNumber'];
        }

        if (requestParameters['purchaseOrderNumber'] != null) {
            queryParameters['purchaseOrderNumber'] = requestParameters['purchaseOrderNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/updateParcelTrackingNumber/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseParcelVoFromJSON(jsonValue));
    }

    /**
     * 
     * 商品修改运单号
     */
    async goodsUpdateParcelTrackingNumberGoodsIdPost(requestParameters: GoodsUpdateParcelTrackingNumberGoodsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseParcelVo> {
        const response = await this.goodsUpdateParcelTrackingNumberGoodsIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新商品信息
     */
    async goodsUpdatePostRaw(requestParameters: GoodsUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateGoodsVoToJSON(requestParameters['addOrUpdateGoodsVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新商品信息
     */
    async goodsUpdatePost(requestParameters: GoodsUpdatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用平台订单号批量更新快递单号
     */
    async goodsUpdateTrackingNumberByGoodsPlatformNoPostRaw(requestParameters: GoodsUpdateTrackingNumberByGoodsPlatformNoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/goods/updateTrackingNumberByGoodsPlatformNo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateTrackingNumberByGoodsPlatformNoVo']!.map(UpdateTrackingNumberByGoodsPlatformNoVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 用平台订单号批量更新快递单号
     */
    async goodsUpdateTrackingNumberByGoodsPlatformNoPost(requestParameters: GoodsUpdateTrackingNumberByGoodsPlatformNoPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.goodsUpdateTrackingNumberByGoodsPlatformNoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
